// extracted by mini-css-extract-plugin
module.exports = {"component":"search-bar-component--3rEE_"};